export default __webpack_public_path__ + "steinberg-wavelab.bea5d718.png";